module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-form', {
    ref: "paramForm",
    staticClass: "addParamForm",
    attrs: {
      "prop": "paramForm",
      "model": _vm.paramForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "参数名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.paramForm.name),
      expression: "paramForm.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请输入参数名"
    },
    domProps: {
      "value": (_vm.paramForm.name)
    },
    on: {
      "input": function($event) {
        _vm.paramForm.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注说明",
      "prop": "remark"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.paramForm.remark),
      expression: "paramForm.remark",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "w-300",
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入备注说明"
    },
    domProps: {
      "value": (_vm.paramForm.remark)
    },
    on: {
      "input": function($event) {
        _vm.paramForm.remark = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择数据表",
      "prop": "table_name"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tableItem),
      expression: "tableItem"
    }],
    staticClass: "w-300",
    attrs: {
      "filterable": "",
      "placeholder": "输入内容搜索"
    },
    domProps: {
      "value": (_vm.tableItem)
    },
    on: {
      "input": function($event) {
        _vm.tableItem = $event
      }
    }
  }, _vm._l((_vm.tableList), function(tableItem) {
    return _c('el-option', {
      attrs: {
        "label": tableItem.name,
        "value": tableItem
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择字段名",
      "prop": "field_name"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramForm.field_name),
      expression: "paramForm.field_name"
    }],
    staticClass: "w-300",
    attrs: {
      "filterable": "",
      "placeholder": "输入内容搜索"
    },
    domProps: {
      "value": (_vm.paramForm.field_name)
    },
    on: {
      "input": function($event) {
        _vm.paramForm.field_name = $event
      }
    }
  }, _vm._l((_vm.fieldList), function(filedItem) {
    return _c('el-option', {
      key: filedItem,
      attrs: {
        "label": filedItem,
        "value": filedItem
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主键ID",
      "prop": "foreign_key"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.paramForm.foreign_key),
      expression: "paramForm.foreign_key",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "输入键名"
    },
    domProps: {
      "value": (_vm.paramForm.foreign_key)
    },
    on: {
      "input": function($event) {
        _vm.paramForm.foreign_key = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否为序列化字段",
      "prop": "is_serialize"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramForm.is_serialize),
      expression: "paramForm.is_serialize"
    }],
    domProps: {
      "value": (_vm.paramForm.is_serialize)
    },
    on: {
      "change": _vm.selectSerialize,
      "input": function($event) {
        _vm.paramForm.is_serialize = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])])]), _vm._v(" "), (_vm.paramForm.is_serialize === 1) ? _c('el-form-item', {
    attrs: {
      "label": "要配置的键",
      "prop": "config_key"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.paramForm.config_key),
      expression: "paramForm.config_key",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "输入键名"
    },
    domProps: {
      "value": (_vm.paramForm.config_key)
    },
    on: {
      "input": function($event) {
        _vm.paramForm.config_key = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-title",
    staticStyle: {
      "color": "#1f2d3d"
    }
  }, [_vm._v("以斜杠区分数组层级，如三维写法config/select/value")])]) : _vm._e(), _vm._v(" "), (_vm.paramForm.is_serialize === 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "参数是否为多组",
      "prop": "groups"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramForm.groups),
      expression: "paramForm.groups"
    }],
    domProps: {
      "value": (_vm.paramForm.groups)
    },
    on: {
      "change": _vm.selectGroups,
      "input": function($event) {
        _vm.paramForm.groups = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("多组,可以自由添加或者删除多组数据")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("单组,如分页，是一个参数值，不能添加多组数据")])])])]) : _vm._e(), _vm._v(" "), (_vm.paramForm.is_serialize === 1) ? _c('div', [_c('el-table', {
    staticStyle: {
      "width": "850px"
    },
    attrs: {
      "data": _vm.paramForm.dimension
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "type": "index",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "是否隐藏",
      "width": "120"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-checkbox', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.is_hidden),
            expression: "scope.row.is_hidden"
          }],
          attrs: {
            "true-label": _vm.selectTrue,
            "false-label": _vm.selectFalse
          },
          domProps: {
            "value": (scope.row.is_hidden)
          },
          on: {
            "input": function($event) {
              scope.row.is_hidden = $event
            }
          }
        }, [_vm._v("隐藏")])])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "列名"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.colume_name),
            expression: "scope.row.colume_name"
          }],
          staticClass: "w-150",
          attrs: {
            "placeholder": "请输入列名"
          },
          domProps: {
            "value": (scope.row.colume_name)
          },
          on: {
            "input": function($event) {
              scope.row.colume_name = $event
            }
          }
        })])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "键名"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.key),
            expression: "scope.row.key"
          }],
          staticClass: "w-150",
          attrs: {
            "placeholder": "请输入键名"
          },
          domProps: {
            "value": (scope.row.key)
          },
          on: {
            "input": function($event) {
              scope.row.key = $event
            }
          }
        })])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.type),
            expression: "scope.row.type"
          }],
          domProps: {
            "value": (scope.row.type)
          },
          on: {
            "input": function($event) {
              scope.row.type = $event
            }
          }
        }, _vm._l((_vm.selectTypeList), function(item) {
          return _c('el-option', {
            key: item,
            attrs: {
              "label": item.title,
              "value": item.type
            }
          })
        }))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "70"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger",
            "disabled": _vm.paramForm.dimension.length === 0
          },
          on: {
            "click": function($event) {
              _vm.deleteDimensionItem(scope.$index)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }
  })]), _vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.paramForm.is_serialize === 1 && _vm.paramForm.groups === 20) ? _c('el-button', {
    staticStyle: {
      "margin-bottom": "40px",
      "width": "850px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addDimensionItem()
      }
    }
  }, [_vm._v("添加维度名")]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "paramFormButton"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitParamData
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3cb0d150!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Parameter/paramForm.vue
// module id = 1830
// module chunks = 2